import React from 'react'
import Container from '../../../../components/Container'
import { FormServicesCountries } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools'

const ServicesCountriesCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormServicesCountries typeForm="create" />
  </Container>
)

export default ServicesCountriesCreate
